import { render, staticRenderFns } from "./ProvisionalOrderStatusTypeSelect.vue?vue&type=template&id=581711f2&scoped=true&lang=pug"
import script from "./ProvisionalOrderStatusTypeSelect.vue?vue&type=script&lang=js"
export * from "./ProvisionalOrderStatusTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581711f2",
  null
  
)

export default component.exports